// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xvC8","left":"styles_left__2dGRC","select":"styles_select__2QSl4"};